var Findation = window.Findation || {};
// eslint-disable-next-line no-use-before-define
var prodcat = prodcat || {};
// eslint-disable-next-line no-use-before-define
var site = site || {};

prodcat.data = prodcat.data || {};

site.translations = site.translations || {};

(function ($, ServiceBus, Topics) {
  'use strict';

  async function hasCookieAccess() {
    // Check if Storage Access API is supported
    if (!document.requestStorageAccess) {
      return true;
    }

    // Check if access has already been granted
    if (await document.hasStorageAccess()) {
      return true;
    }

    // Check the storage-access permission
    let permission;
    try {
      permission = await navigator.permissions.query(
        {name: 'storage-access'}
      );
    } catch (error) {
      // storage-access permission not supported. Assume no cookie access.
      return false;
    }

    if (permission) {
      if (permission.state === 'granted') {
        try {
          await document.requestStorageAccess();
          return true;
        } catch (error) {
          return false;
        }
      } else if (permission.state === 'prompt') {
        return false;
      } else if (permission.state === 'denied') {
        // Not used: see https://github.com/privacycg/storage-access/issues/149
        return false;
      }
    }

    return false;
  }

  const isIframe = window.location !== window.parent.location;

  const goToOnParent = function (url) {
    window.parent.location.href = url;
  };
  const setShade = function (shadeName) {
    const $shadeGrid = $('.js-product-full__shades-container');

    if ($shadeGrid.length > 0) {
      $shadeGrid.find('[data-shade-name="' + shadeName + '"]').trigger('click');
    }
  };
  const setShadeOnParent = function (shadeName) {
    const $shadeGrid = $('.js-product-full__shades-container', window.parent.document);

    if ($shadeGrid.length > 0) {
      $shadeGrid.find('[data-shade-name="' + shadeName + '"]').trigger('click');
    }
  };
  const changeSkuOnParent = function (productCode,) {
    const postMsg = {
      _elc_action: 'selectShade',
      skuBaseId: productCode
    }

    window.parentIFrame.sendMessage(postMsg, '*');
  };

  const triggerEventOnParent = function (value) {
    const parts = value.split('||');
    const eventName = parts[0];
    const eventPayload = parts[1] || {};

    switch (eventName) {
      case 'live_chat':
        isVulcan() && window.parentIFrame.sendMessage({_elc_action: 'openSalesforceChat'}, '*');
        break;
      case 'open_live_chat':
        window.parentIFrame.sendMessage({ _elc_action: 'openLiveChat' }, '*');
        break;
      case 'open_vto':
        window.parentIFrame.sendMessage({ _elc_action: 'openVTO', targetClassName: eventPayload }, '*');
        break;
      default:
        $(window.parent.document).trigger(eventName, eventPayload);
    }
  };

  const scrollIntoViewOnParent = function (value) {
    const isNumeric = !isNaN(parseFloat(value)) && isFinite(value);
    const postMsg = {
      _elc_action: 'scrollIntoView',
      scrollY: isNumeric ? value : 0,
      scrollTarget: !isNumeric ? value : '',
      scrollPadding: 155
    };

    window.parentIFrame.sendMessage(postMsg, '*');
  };

  const findationWidgetOnParent = function () {
    const postMsg = {
      _elc_action: 'findationWidget'
    };

    window.parentIFrame.sendMessage(postMsg, '*');
  };

  const analyticsOnParent = function (analyticsAction) {
    const postMsg = {
      _elc_action: 'findationWidget',
      _elc_analytics_action_name: analyticsAction
    };

    window.parentIFrame?.sendMessage(postMsg, '*');
  };

  const addToBag = function (skuBaseId) {
    $(document).trigger('perlgem.cart.addItem', skuBaseId);
  };

  const productClick = function (productId) {
    site.track.productClick({
      product_id: [productId]
    });
  };

  const skuChange = function (skuBaseId) {
    const skuData = prodcat.data.getSku(skuBaseId);
    const prodData = prodcat.data.getProduct(skuData.PRODUCT_ID);

    site.track.skuChange({
      product_sku: [skuData.SKU_ID],
      product_id: [skuData.PRODUCT_ID],
      product_product_code: [skuData.PRODUCT_CODE],
      product_price: [skuData.PRICE.toString()],
      product_shade: [skuData.SHADENAME],
      product_size: [skuData.PRODUCT_SIZE],
      product_name: [prodData.PROD_RGN_NAME],
      product_base_id: [prodData.PROD_BASE_ID],
      product_url: [prodData.url],
      product_category: [(prodData.DEFAULT_CAT_ID)?.replace(/\D/g, '')]
    });
  };

  $(document).on('findation-initialised', function () {

    Findation.onActionReceived = function (payload) {
      const parts = payload.split('::');
      const action = parts[0];
      const value = parts[1];

      switch (action) {
        case 'goTo':
          isIframe && goToOnParent(value);
          break;
        case 'setShade':
          !isIframe && setShade(value);
          isIframe && setShadeOnParent(value);
          break;
        case 'changeSku':
          isIframe && changeSkuOnParent(value);
          break;
        case 'event':
          isIframe && triggerEventOnParent(value);
          break;
        case 'scrollIntoView':
          isIframe && scrollIntoViewOnParent(value);
          break;
        case 'findationWidget':
          isIframe && findationWidgetOnParent(value);
          break;
        case 'analytics':
          isIframe && analyticsOnParent(value);
          break;
        case 'addToBag':
          !isIframe && addToBag(value);
          break;
        case 'productClick':
          !isIframe && productClick(value);
          break;
        case 'skuChange':
          !isIframe && skuChange(value);
          break;
        default:
      }
    };

    Findation.resultsWillRender = function (html) {
      // add pre render actions like product sku replacements
      return html;
    };


    Findation.widgetDidOpen = function () {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('widget_opened');
    };

    Findation.widgetDidClose = function () {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('widget_closed');
    };

    Findation.onSearchComplete = function (data) {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('widget_searchComplete');

      if (data.matchSuccess) {
        analyticsOnParent('widget_recommendedShade');
      } else {
        analyticsOnParent('widget_norecommendation');
      }
    };
  });

  const isVulcan = function() {
    return window.parent._platform === 'vulcan';
  }

  const setClickEvents = function () {
    const $findationWidget = $('.js-findation-widget__wrapper');
    const $findationCta = $('.js-findation-widget__wrapper .js-button');
    let findationKey = $findationWidget.data('findation-key');
    let options = {};
    const selector = !isIframe ? '.js-product-full__addtobag-block' : '.js-findation-widget__wrapper';
    const locationHref = !isIframe ? window.location.href : window.parent.document.location.href;

    $findationCta.once().on('click', async function (e) {
      e.preventDefault();
      const hasAccess = !isIframe || await hasCookieAccess();

      if (hasAccess) {
        // Grab the key again, changes on translated sites.
        findationKey = $findationWidget.data('findation-key');

        if (isIframe) {
          options = {
            productUrl: decodeURI(locationHref)
          }
        }

        $(document).trigger('findation-load', {findationKey: findationKey, selector, options});
        $('html, body').animate({ scrollTop: 0 }, 500);
      }
    });
  }

  $(function () {
    setClickEvents();
    const pageLocation = !isIframe ? window.location : window.parent.document.location;

    // Get the findation widget from mount point wrapper.
    const wrapperSelector = '.js-findation-widget__wrapper';
    const findationKey = $(wrapperSelector).data('findation-key');
    const options = {
      productUrl: decodeURI(pageLocation.href)
    };

    if (findationKey && isIframe) {
      // Preload the Findation widget when inside an iFrame.
      $(document).trigger('findation-preload', {
        findationKey,
        selector: wrapperSelector,
        options
      });
    }
  });
  
})(jQuery, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});

